// Texte de la politique de confidentialité — source de vérité unique
const PRIVACY_POLICY_TEXT = `# Politique de Confidentialité et Utilisation des Données

## 1. Utilisation interne des données

Les informations collectées (rapports, photos, pièces d'identité, cartes de service, données personnelles) sont utilisées **exclusivement par Gazelle Security SARLU** dans le cadre de ses activités.

En cas de **faute grave** ou **manquement disciplinaire**, ces données pourront servir de base à des **poursuites internes ou légales**.

## 2. Interdiction de divulgation

Les utilisateurs **n'ont aucun droit** de divulguer, partager ou transmettre les informations de la plateforme à des tiers sans l'accord écrit de l'entreprise.

Toute violation de cette règle constitue une **faute grave** et pourra entraîner des sanctions disciplinaires ou judiciaires.

## 3. Engagement de l'utilisateur

Avant d'accéder à la plateforme, chaque utilisateur doit :

- ✅ Reconnaître que ses données peuvent être utilisées par l'entreprise en cas de faute grave.
- ✅ S'engager à ne pas divulguer les informations confidentielles sans autorisation.
- ✅ Accepter que toute utilisation abusive des données entraîne des sanctions.

---

*« J'ai lu et j'accepte la politique de confidentialité et les conditions d'utilisation des données de Gazelle Security SARLU. »*`;

export default PRIVACY_POLICY_TEXT;
